import { LoginAction, LoginTypes, State } from '../types';
import { initialState } from '../types';
import { Reducer } from 'redux';

const getLogin: Reducer<State, LoginAction> = (
  state: any = initialState.login,
  action: LoginAction,
): State => {
  switch (action.type) {
    case LoginTypes.FLOW:
      return {
        ...state,
        flow: action.payload,
      };
    case LoginTypes.EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    default:
      return state;
  }
};

export default getLogin;
